<app-form-input-group>
  <span *ngIf="label" custom-label [ngClass]="customLabelClass">
    {{ label }}
  </span>

  <app-form-autocomplete-v2
    #content
    [placeholder]="placeholder"
    [autoFilter]="true"
    [items]="suggestions"
    [inputStyle]="inputStyle"
    [iconName]="iconType.Run"
    [formControl]="sport"
    (click)="preventLabelBehaviour($event)"
    (selectItemEvent)="selectSportItem($event)"
  ></app-form-autocomplete-v2>
</app-form-input-group>
